
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","version":"1.1","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M12.5 14.6h-9c-.3 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8v-3.1c0-.3.3-.6.6-.6s.6.3.6.6v3h8.8V5.8L9.3 2.7H3.6v2.8c0 .3-.3.6-.6.6s-.6-.3-.6-.6V2.6c0-.3.1-.6.3-.8s.5-.3.8-.3h6c.2 0 .3 0 .4.2l3.5 3.5c.1.1.2.3.2.4v8c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M13 6.1H9.5c-.3 0-.6-.3-.6-.6V2c0-.3.3-.6.6-.6s.6.3.6.6v2.9H13c.3 0 .6.3.6.6s-.3.6-.6.6zM6.8 8.5h-5c-.3 0-.6-.3-.6-.6s.3-.6.6-.6h5c.3 0 .6.3.6.6s-.3.6-.6.6z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M6 10.1c-.2 0-.3 0-.4-.2-.2-.2-.2-.6 0-.9l1.1-1.1-1.1-1.1c-.2-.2-.2-.6 0-.9s.6-.2.9 0L8 7.4c.1.1.2.3.2.4s0 .3-.2.4L6.5 9.7c-.1.1-.3.2-.4.2z"}})])
          )
        }
      }
    